export function removeSpace(content: string): string {
    return content.replace(/\s/g, "");
}